<template>
    <div id="offPF">
        <div class="img-topo d-flex align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8 offset-md-2">
                        <div>
                            <h1 class="color-white big-title f-w-700 text-center">Unidades Desligadas</h1>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
        <div class="tableCont">
            <table class="table">
                <thead>
                    <tr>
                    <th scope="col">Unidade</th>
                    <th scope="col">Contato</th>
                    <th scope="col">Motivo do Encerramento</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td>Campos Elíseos</td>
                    <td>(11)97089-4497</td>
                    <td>Ponto prejudicado pela pandemia</td>
                    </tr>
                    <tr>
                    <td>Pimentas</td>
                    <td>(11)97534-4569</td>
                    <td>Gestão</td>
                    </tr>
                    <tr>
                    <td>República</td>
                    <td>(11)98617-9132</td>
                    <td>Ponto prejudicado pela pandemia</td>
                    </tr>
                    <tr>
                    <td>Itapecerica da Serra</td>
                    <td>(11)96129-0630</td>
                    <td>Gestão</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
#offPF{
    background: #e0a638; /* Old browsers */
    background: -moz-linear-gradient(45deg,  #e0a638 1%, #f38235 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0a638', endColorstr='#f38235',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    padding-top: 100px;
}
.img-topo {
    background-size: cover;
    background-position: 0 -80px;
    height: 300px;
} 
.tableCont{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 5%;
}
.table {
    width: 70%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: white;
    margin-top: 2%; 
    border-radius: 6px;  
}
</style>